/* eslint-disable */
import {
  compose as _compose, curry, nthArg, prop,
} from 'ramda';
import { async } from '@555platform/utility-belt.js';
import createResolver from './baseResolver';
import { AuthenticationRequiredError } from '../errors';

export const root = nthArg(0);

export const args = nthArg(1);

export const ctx = nthArg(2);

const propExtractor = curry((arg, targetProp) => _compose(prop(targetProp), arg));

export const rootProp = propExtractor(root);

export const argProp = propExtractor(args);

export const ctxProp = propExtractor(ctx);

export const authenticatedResolver = createResolver((_, __, context) => {
  const user = prop('user', context);
  if (!user) throw new AuthenticationRequiredError();
});

export const unauthenticatedResolver = createResolver(() => {});

export const compose = _compose(authenticatedResolver.createResolver, async.compose);
